export default {
  defaultTheme: 'test',
  cellGroupCount: 9,
  col: 10,
  row: 10,
  lineDelay: 500
}



// WEBPACK FOOTER //
// ./src/config.js